import {createButton, createElement, htmlStringToElement} from "./utils_element";
import './equipment_list'

export const initCollection = (formElementId, bindEquipmentList = false) => {
    let collectionHolder = document.getElementById(formElementId),
        newItemWrapper = createElement('div', 'input-group mb-2 item'),
        addTagButton = document.getElementById('addItem'),
        formElements = collectionHolder.querySelectorAll('div.item');
    for (let i = 0; i < formElements.length; i++) {
        addBtnFormDeleteDraft(formElements[i]);
    }
    collectionHolder.appendChild(newItemWrapper);
    collectionHolder.dataset.index = formElements.length;
    addTagButton.onclick = () => {
        addTagForm(collectionHolder, newItemWrapper)
    }
};

const addBtnFormDeleteDraft = (formElement) => {
    let removeButton = createButton('btn text-danger bg-light btn-outline-gray-2 px-2 border-left-0 rounded-right', '', 'fa fa-times');
    formElement.append(removeButton);
    removeButton.onclick = () => {
        formElement.remove();
    };
    return formElement;
};

const addTagForm = (collectionHolder, newItemWrapper) => {
    let prototype = collectionHolder.dataset.prototype,
        index = parseInt(collectionHolder.dataset.index),
        newForm = htmlStringToElement(prototype);
    newForm.innerHTML = newForm.innerHTML.replace(/__name__/g, index);
    collectionHolder.dataset.index = index + 1;
    addBtnFormDeleteDraft(newForm);

    newItemWrapper.before(newForm);
    $(newForm).find('button').EquipmentListHandler();
    document.dispatchEvent(new Event('addTagForm'))
};



// WEBPACK FOOTER //
// ./assets/js/form_collection.js